import { crudGetters } from "@/utils/store.js";
import isEmpty from "lodash/isEmpty.js"
import { PublicObject } from "@/utils/dto/objects.js";

const BASE_URL = process.env.BASE_URL_V2

export const state = () => ({
  mainObjects: [],
})

export const mutations = {
  SET_MAIN_OBJECTS(state, payload) {
    state.mainObjects = payload
  }
}

export const actions = {
  async publicObjects({}, params = {}) {
    return this.$axios.$get(`${BASE_URL}/public/modal_objects/`, {
      params: params
    })
      .then(response => {
        return {
          ...response,
          items: response.items.map(item => new PublicObject(item))
        }
      })
  },
  async publicObject({}, id_or_slug) {
    return this.$axios.$get(`${BASE_URL}/public/modal_objects/${id_or_slug}/`)
  },
  async checkCanEdit({}, id_or_slug) {
    return this.$axios.$get(`${BASE_URL}/public/modal_objects/${id_or_slug}/can_edit/`)
  },
  async sameObjects({}, params = {}) {
    return this.$axios.$get(`${BASE_URL}/admin/modal_object_edit/same_objects/${params.id_or_slug}/`, {
      params: {
        ...params.params
      }
    })
  },
  async propertiesTemplates({}, id_or_slug) {
    return this.$axios.$get(`${BASE_URL}/admin/modal_object_edit/properties_templates/${id_or_slug}/`)
  },
  async linkedObjectsTypes({}, id_or_slug) {
    return this.$axios.$get(`${BASE_URL}/admin/modal_object_edit/linked_objects_types/${id_or_slug}/`)
  },
  async propertyTemplatesList({}, type) {
    if(type?.length) {
      return this.$axios.$get(`${BASE_URL}/admin/modal_object_edit/property_templates_list/?types=${type}`)
    }
    else{
      return {
        "total":0,
        "items_len":0,
        "items":[],
        "data":{},
        "debug":{}
      }
    }
  },
  async editSameObject({}, payload) {
    return this.$axios.$post(`${BASE_URL}/admin/modal_object_edit/`, payload)
  },
  async deleteMany(state, object_ids) {
    return this.$axios.$delete(`${BASE_URL}/admin/objects/many/${object_ids.join(',')}/`)
  },
  async deleteObject({}, id_or_slug) {
    return this.$axios.$delete(`${BASE_URL}/admin/modal_objects/${id_or_slug}/`)
  },
  async fetchObjects({ commit }, params = {}) {
    const response = await this.$axios.$get(`${BASE_URL}/admin/modal_objects/`, {
      params: {
        ...params
      }
    })
    return response
  },
  async hideObject({}, id_or_slug) {
    return this.$axios.$post(`${BASE_URL}/admin/modal_objects/hide/${id_or_slug}/`)
  },
  async unhideObject({}, id_or_slug) {
    return this.$axios.$post(`${BASE_URL}/admin/modal_objects/unhide/${id_or_slug}/`)
  },
  async getMainObjects({ state, commit, dispatch }, params = {}) {
    const objects = await dispatch('publicObjects', {
      q: '',
      limit: params?.limit ?? 8,
      offset: params?.offset ?? 0,
      with_events: true,
      order: '-total_score'
    })

    if (params?.offset && params?.offset > 0) {
      commit('SET_MAIN_OBJECTS', [...state.mainObjects, ...objects.items])
    } else {
      commit('SET_MAIN_OBJECTS', objects.items)
    }

    return state.mainObjects
  },
}

export const getters = {
  ...crudGetters,
  getMainObjects: (state) => state.mainObjects
}
